// Maps a free-text review location ("USA", "Australia", "Sydney, Australia")
// to an ISO 3166-1 alpha-2 code, so the card can show that country's flag.
// Only the last comma-separated part is read. Full English country names come
// from Intl.DisplayNames; ALIASES covers the common short forms. Bare
// two-letter codes are NOT matched ("CA" is as likely California as Canada),
// so an unrecognised location shows no flag rather than a wrong one.

const ALIASES = {
  usa: 'US',
  us: 'US',
  'u.s.': 'US',
  'u.s.a.': 'US',
  america: 'US',
  'united states of america': 'US',
  uk: 'GB',
  'u.k.': 'GB',
  england: 'GB',
  scotland: 'GB',
  wales: 'GB',
  'northern ireland': 'GB',
  'great britain': 'GB',
  britain: 'GB',
  uae: 'AE',
  'south korea': 'KR',
  russia: 'RU',
  'czech republic': 'CZ',
  holland: 'NL',
  'the netherlands': 'NL',
  vietnam: 'VN',
  turkey: 'TR',
  'ivory coast': 'CI',
  // Intl's own names for these carry a qualifier ("Hong Kong SAR China").
  'hong kong': 'HK',
  macau: 'MO',
  macao: 'MO',
  myanmar: 'MM',
  burma: 'MM',
  palestine: 'PS',
}

// Retired or reserved codes Intl still names, often with a current country's
// name ("DD" -> "Germany", "UK" -> "United Kingdom"), plus non-country regions.
const SKIP = new Set([
  'AN', 'BU', 'CS', 'DD', 'DY', 'FX', 'HV', 'NH', 'NT', 'RH', 'SU', 'TP', 'UK', 'VD', 'YD', 'YU', 'ZR',
  'EU', 'EZ', 'UN', 'QO', 'ZZ',
])

let nameIndex = null

function countryNameIndex() {
  if (nameIndex) return nameIndex
  nameIndex = new Map()
  let names
  try {
    names = new Intl.DisplayNames(['en'], { type: 'region' })
  } catch {
    return nameIndex
  }
  for (let a = 65; a <= 90; a += 1) {
    for (let b = 65; b <= 90; b += 1) {
      const code = String.fromCharCode(a, b)
      if (SKIP.has(code)) continue
      let name
      try {
        name = names.of(code)
      } catch {
        continue
      }
      // Unassigned codes come back unchanged. First code wins, so a reserved
      // duplicate never replaces the real one (UK -> "United Kingdom" after GB).
      const key = name && name !== code ? name.toLowerCase() : null
      if (key && !nameIndex.has(key)) nameIndex.set(key, code)
    }
  }
  return nameIndex
}

export function countryCode(location) {
  if (!location) return null
  const key = String(location).split(',').pop().trim().toLowerCase()
  if (!key) return null
  return ALIASES[key] || countryNameIndex().get(key) || null
}

/** 20px-wide flag image (with 2x/4x sources) from flagcdn.com, or null. */
export function flagImage(code) {
  if (!code) return null
  const c = code.toLowerCase()
  return {
    src: `https://flagcdn.com/w20/${c}.png`,
    srcSet: `https://flagcdn.com/w40/${c}.png 2x, https://flagcdn.com/w80/${c}.png 4x`,
  }
}
